module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-medicalSolutions.28aa9226.png";